<div class="side-menu-container" [ngClass]="{ 'overview' : isOverViewPage}">
  @if (isOverViewPage) {
    <div class="h3-text select-account-title">Select Accounts</div>
    @if (isOverViewPage) {
      <label for="vd-picker" class="subtitle mt-3">Portfolio as of </label>
    }
    @if (isOverViewPage) {
      <VDPicker id="vd-picker" class="vd-picker" (dateChange)="onValuationDateChange($event)" />
    }
    <div class="spacer mb-4"></div>
  }
  <div class="d-lg-none mobile-menu">
    <button tabindex="0" class="side-menu-button opened" style="width: 100% !important;" (click)="closeMenu()" aria-label="Close the Menu">{{menuTitle}}<i class="fa fa-close pull-right"></i></button>
    @if (isOverViewPage) {
      <label for="vd-picker-mobile" class="subtitle mt-3" [ngClass]="{ 'IsMenuOpened' : IsMenuOpened}">Portfolio as of </label>
    }
    @if (isOverViewPage) {
      <VDPicker id="vd-picker-mobile" class="vd-picker" [ngClass]="{ 'IsMenuOpened' : IsMenuOpened}" (dateChange)="onValuationDateChange($event)" />
    }
    <button class="side-menu-button" id="side-menu-button" [ngClass]="{'fix_menu': fix_menu}" [ngStyle]="{'top':menu_height + 'px'}" (click)="openMenu()">
      @if (isOverViewPage) {
        <span id="select-accounts">Select Accounts</span>
      }
      @if (!isOverViewPage) {
        <span>{{curentItem || defaultTitle}}</span>
      }
      <i class="fa fa-angle-down dropdown-button"></i>
    </button>
  </div>

  <div [ngClass]="{ 'd-none d-lg-block' : !IsMenuOpened}">
    <ng-content />
  </div>

  <ul class="side-menu-content"  [ngClass]="isOverViewPage?'overview':''">
    <ng-template #recursiveList let-menuItems>
      @for (i of menuItems; track i) {
        <li [ngClass]="{'active':i.active || !i.title, 'hasSubItems':i.items && i.items.length > 0, 'opened' : i.opened, 'hasNew':i.hasNew}" class="{{i.class}}">
          @if (i.title && i.items && i.items.length > 0) {
            <button class="sidebar-nav-button" tabindex="0" (click)="groupClicked(i)" title="{{i.title}}"><span>{{i.title}}</span></button>
          }
          @if (i.title && !(i.items && i.items.length > 0)) {
            <button class="sidebar-nav-button" tabindex="0" (click)="itemClicked(i)" title="{{i.title}}"><span>{{i.title}}</span></button>
          }
          @if (i.items && i.items.length > 0) {
            <ul>
              <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: i.items }" />
            </ul>
          }
        </li>
      }
    </ng-template>
    <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: menuItems }" />
  </ul>
</div>
